import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

// Define the gtag function type for TypeScript
declare global {
  interface Window {
    dataLayer: Array<Record<string, any> | IArguments>;
    gtag?: (command: string, action: any, params?: any) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private analyticsId = environment.googleAnalytics.measurementId;
  private isEnabled = environment.googleAnalytics.enabled;

  constructor(
    private router: Router
  ) {
    if (this.isEnabled) {
      this.initGoogleAnalytics();
    }
  }

  // Initialize Google Analytics by dynamically loading scripts
  private initGoogleAnalytics(): void {
    try {
      // Inject script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${this.analyticsId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) { window.dataLayer.push(arguments); }

      gtag('js', new Date());
      gtag('config', this.analyticsId, { 'send_page_view': false });

      // Make the tracking available globally
      window.gtag = gtag;
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.trackPageView(event.urlAfterRedirects);
      });

    } catch (error) {
      console.error('Error initializing Google Analytics:', error);
    }
  }

  // Track page views
  public trackPageView(pagePath: string): void {
    if (typeof window.gtag !== 'undefined' && this.isEnabled) {
      window.gtag('config', this.analyticsId, {
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }
}
